import useRestList from "../../_shared/hooks/useRestList"
import { useEffect, useState } from "react"

import YellowButton from "../../../assets/images/icons/Pulsante_giallo.svg"
import "react-slideshow-image/dist/styles.css"
import { Navigate, useParams } from "react-router-dom"

import BackIcon from "../../_shared/components/BackIcon"
import AppText from "../../_shared/components/AppText"
import SideMenu from "../../_shared/components/SideMenu"
import SlideImages from "../../_shared/components/SlideImages"

export default function CompositionImage(props) {
	const { setSplash } = props
	useEffect(() => setSplash(false), [])
	const [rooms] = useRestList("/rooms")
	const [products] = useRestList("/products")

	const { id } = useParams()

	const [layout, setLayout] = useState()
	const [composition, setComposition] = useState()
	const [selectedCompositionImageIndex, setSelectedCompositionImageIndex] =
		useState()

	const [selectedElement, setSelectedElement] = useState()

	function setData(layout, composition) {
		setLayout(layout)
		setComposition(composition)
	}

	useEffect(() => {
		setSelectedCompositionImageIndex(0)
	}, [composition])

	useEffect(() => {
		rooms.map((room) =>
			room.layouts.map(
				(layout) =>
					layout?.compositions?.some((x) => x?._id === id) &&
					setData(
						layout,
						layout?.compositions?.find((x) => x?._id === id)
					)
			)
		)
	}, [id, rooms])

	function getElement() {
		return products?.some((x) => x.id === selectedElement) ? (
			selectedElement === "63f76c2f5012d8002666afa7" ? (
				<Navigate to={`/products/slide/63f625f19c51f100273c5f09`}></Navigate>
			) : (
				<Navigate
					to={`/product/${
						products?.find((x) => x.id === selectedElement)?.category?.id
					}/${selectedElement}`}
				></Navigate>
			)
		) : (
			<Navigate to={`/composition/${selectedElement}`}></Navigate>
		)
	}

	function renderElement() {
		return (
			<div>
				<div className="rowFullLine">
					<div>
						<div className="row">
							<div>
								<BackIcon></BackIcon>
							</div>
							<div>
								<AppText bold big>
									{composition?.code}
								</AppText>
								<AppText bold> {layout?.layoutName?.it}</AppText>
								<AppText light> {layout?.layoutName?.en}</AppText>
							</div>
						</div>
					</div>
				</div>

				<SlideImages
					image={
						composition?.compositionDetail[selectedCompositionImageIndex]
							?.imageDetail
					}
					pickPoints={
						composition?.compositionDetail[selectedCompositionImageIndex]
							.pickPoints
					}
					onPlus={() =>
						selectedCompositionImageIndex ===
						composition?.compositionDetail.length - 1
							? setSelectedCompositionImageIndex(0)
							: setSelectedCompositionImageIndex(
									selectedCompositionImageIndex + 1
							  )
					}
					onMinus={() =>
						selectedCompositionImageIndex === 0
							? setSelectedCompositionImageIndex(
									composition?.compositionDetail.length - 1
							  )
							: setSelectedCompositionImageIndex(
									selectedCompositionImageIndex - 1
							  )
					}
					showArrows={composition?.compositionDetail?.length > 1}
					style={{
						maxWidth: "80vw",
						maxHeight: "80vh",
						marginLeft: 30,
						marginTop: 30,
					}}
					marginLeft
					noCenter
					onClickPP={setSelectedElement}
				></SlideImages>
			</div>
		)
	}

	return selectedElement ? (
		getElement()
	) : (
		<div className="rootMenu">
			<SideMenu></SideMenu>
			<div className="rootContent">
				<div>{composition && renderElement()}</div>
			</div>
		</div>
	)
}
const styles = {
	imageContainer: {
		position: "relative",
		aspectRatio: 1.414,
		marginLeft: 30,
		marginTop: 20,
		height: "80vh",
	},
	relativeImage: {
		width: "100%",
		height: "100%",
		objectFit: "contain",
		objectPosition: "left",
		// position: "center",
	},
}
